import { authGuardFn } from '@auth0/auth0-angular';

// Re-export the official Auth0 guard — handles loading state,
// loginWithRedirect(), and appState.returnTo automatically.
export const authGuard = authGuardFn;
